import { createTheme } from "@fluentui/react";

export const lightTheme = createTheme({
	palette: {
		themePrimary: "#ff0004",
		themeLighterAlt: "#fff5f5",
		themeLighter: "#ffd6d7",
		themeLight: "#ffb3b4",
		themeTertiary: "#ff6669",
		themeSecondary: "#ff1f22",
		themeDarkAlt: "#e60004",
		themeDark: "#c20003",
		themeDarker: "#8f0002",
		neutralLighterAlt: "#faf9f8",
		neutralLighter: "#f3f2f1",
		neutralLight: "#edebe9",
		neutralQuaternaryAlt: "#e1dfdd",
		neutralQuaternary: "#d0d0d0",
		neutralTertiaryAlt: "#c8c6c4",
		neutralTertiary: "#a19f9d",
		neutralSecondary: "#605e5c",
		neutralPrimaryAlt: "#3b3a39",
		neutralPrimary: "#323130",
		neutralDark: "#201f1e",
		black: "#000000",
		white: "#ffffff",
	},
});
export const darkTheme = createTheme({
	palette: {
		themePrimary: "#ff5054",
		themeLighterAlt: "#0a0303",
		themeLighter: "#290d0d",
		themeLight: "#4d1819",
		themeTertiary: "#992f31",
		themeSecondary: "#e04648",
		themeDarkAlt: "#ff6163",
		themeDark: "#ff797c",
		themeDarker: "#ff9c9e",
		neutralLighterAlt: "#2b2b2b",
		neutralLighter: "#333333",
		neutralLight: "#414141",
		neutralQuaternaryAlt: "#4a4a4a",
		neutralQuaternary: "#515151",
		neutralTertiaryAlt: "#6f6f6f",
		neutralTertiary: "#c8c8c8",
		neutralSecondary: "#d0d0d0",
		neutralPrimaryAlt: "#dadada",
		neutralPrimary: "#ffffff",
		neutralDark: "#f4f4f4",
		black: "#f8f8f8",
		white: "#222222",
	},
});
